













import { Component, Vue } from 'vue-property-decorator';
import NavBar from '@/components/layout/NavBar.vue';
import { NavigationSection } from '@/types/types';
import { PartnerFields } from '@/types/graphql/schemaTypes';
import NavBarNavigation from '@/components/layout/NavBarNavigation.vue';

// gql
import fetchPartnerList from '@/graphql/queries/partners/FetchPartnerList.gql';

@Component({
  apollo: {
    partner: {
      query: fetchPartnerList,
      variables() {
        return {
          partnerId: this.$route.params.id
        };
      },
      update: data => data && data.partners[0],
      fetchPolicy: 'cache-first'
    }
  },
  components: {
    NavBar,
    NavBarNavigation
  }
})
export default class PartnerMain extends Vue {
  partner: PartnerFields | null = null;
  get navigationSections(): NavigationSection[] {
    return this.partner ? [{
      i18nKey: 'partners.navbar.details',
      name: 'partnerDetails',
      params: { id: this.partner.id }
    },
    {
      i18nKey: 'partners.navbar.members',
      name: 'partnerMembers',
      params: { id: this.partner.id }
    }
    ] : [];
  }

  get getCurrentParamId() {
    return this.$route?.params?.id;
  }
}
